import React from 'react';
import PropTypes from 'prop-types';

class InputRadioButton extends React.Component {
  render () {
    const { label, labelClassName, ...others } = this.props;
    return (
      <label className={this.props.className}>
        <input type="radio" {...others} className="push-half--right" />
        <span className={labelClassName}>{label}</span>
      </label>
    );
  }
}

InputRadioButton.propTypes = {
  label: PropTypes.any.isRequired,
};

InputRadioButton.defaultProps = {
  className: '',
  labelClassName: '',
};

export default InputRadioButton;



// WEBPACK FOOTER //
// ./src/common/views/form/InputRadioButton.js